import { AxiosResponse } from 'axios';

export interface RemoteErrorResponse {
  id: string;
  message: string;
  type: string;
}

export class PTEXPRemoteError extends Error {
  errorId?: string;
  response?: AxiosResponse<RemoteErrorResponse>;

  constructor(message: string, response?: AxiosResponse<RemoteErrorResponse>) {
    super(message);
    this.name = 'PTEXPRemoteError';
    this.errorId = response?.data?.id;
    this.response = response;
  }
}
